import {
  ActivitySpinnerSize,
  ActivitySpinnerWidget,
  ButtonType,
  ButtonWidget,
  DialogPositioningBehavior,
  DialogType,
  TabStyles
} from '@tableau/widgets';
import * as React from 'react';
import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { ReactModalOptions } from '../../ts/services/ReactModalService';
import {
  buttonStyleSubmitting,
  cancelButtonStyle,
  DIALOG_WIDTH,
  dialogBodyStyle
} from './styles/ExternalContentActionsStyles';
import {
  ButtonContainerDiv,
  HelpTextDiv,
  REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID,
  RemoveBodyDiv,
  SpinnerDiv
} from './styles/RemoveExternalContentActionsStyles';

export interface RemoveExternalContentDialogProps {
  readonly name: string;
  readonly submit: () => void;
  readonly cancel: () => void;
}

export interface RemoveExternalContentDialogState {
  readonly isSubmitting: boolean;
}

export class RemoveExternalContentDialog extends React.Component<RemoveExternalContentDialogProps, RemoveExternalContentDialogState> {
  constructor(props: RemoveExternalContentDialogProps) {
    super(props);
    this.state = {
      isSubmitting: false
    };
  }

  private onSubmit = () => this.setState({ isSubmitting: true }, this.props.submit);

  private onCancel = () => this.setState({ isSubmitting: true }, this.props.cancel);

  public render(): React.ReactNode {
    return (
      <>
        <RemoveBodyDiv>
          <HelpTextDiv>{ Messages.removeAssetDialogPromptText({ ITEM_NAME: this.props.name }) }</HelpTextDiv>
          <HelpTextDiv>{ Messages.removeAssetDialogPromptHelp() }</HelpTextDiv>
        </RemoveBodyDiv>
        <ButtonContainerDiv>
          <ButtonWidget
            disabled={ this.state.isSubmitting }
            testId={ REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID }
            buttonType={ ButtonType.Outline }
            handleClick={ this.onCancel }
            style={ cancelButtonStyle }>
            <span>{ Messages.cancel() }</span>
          </ButtonWidget>
          <ButtonWidget
            disabled={ this.state.isSubmitting }
            testId={ REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID }
            buttonType={ ButtonType.Attention }
            style={ this.state.isSubmitting ? buttonStyleSubmitting : undefined }
            handleClick={ this.onSubmit }>
            {
              this.state.isSubmitting ?
                <SpinnerDiv><ActivitySpinnerWidget spinnerSize={ ActivitySpinnerSize.Small } /></SpinnerDiv> :
                <span>{ Messages.remove() }</span>
            }
          </ButtonWidget>
        </ButtonContainerDiv>
      </>
    );
  }
}

export function removeExternalContentModalOptions(props: RemoveExternalContentDialogProps): ReactModalOptions {
  return {
    title: Messages.removeAssetDialogTitle(),
    testId: REMOVE_EXTERNAL_CONTENT_DIALOG_TEST_ID,
    type: DialogType.NormalWithTitleBar,
    showCloseButton: false,
    positioningBehavior: DialogPositioningBehavior.Centered,
    dialogWidth: DIALOG_WIDTH,
    dialogBodyStyle: dialogBodyStyle,
    dialogContent: <RemoveExternalContentDialog { ...props } />,
  };
}

